'use client';

import { FAQAccordion } from './faq-accordion';
import { LegalLinks } from './legal-links';
import type { FAQItem } from '../utils/parse-docx';

export function HelpCenterContent({ faqs }: { faqs: FAQItem[] }) {
  return (
    <FAQAccordion faqs={faqs}>
      {(searchQuery) => <LegalLinks searchQuery={searchQuery} />}
    </FAQAccordion>
  );
}
